<div class="invitations-container">
    <h4>Invitations</h4>
    <br>
    <form [formGroup]="statusSelectForm">
        <div>
            <h5>Status</h5>
            <mat-form-field appearance="outline">
                <mat-select formControlName="status" id="status" placeholder="Select" [(value)]="selectedStatus" (selectionChange)="statusChange()">
                    <mat-option *ngFor="let status of invitationStatuses;" [value]="status.value">
                        {{ status.key }} invitations
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <br>
    <p-table *ngIf="!isMobile && filteredInvitations.length > 0" [value]="filteredInvitations" class="invitations-table">
        <ng-template pTemplate="header">
            <thead class="invitations-table__table-header">
                <th>Investor</th>
                <th>Expires</th>
                <th></th>
            </thead>
        </ng-template>
        <ng-template pTemplate="body" let-invitation >
            <tr class="invitations-table__table-row">
                <td>{{invitation.legalEntityName}}</td>
                <td>{{invitation.expiresAt}}</td>
                <td>
                    <span *ngIf="isPending" class="invitations-table__button-container">
                        <ng-container *ngTemplateOutlet="invitationButtons; context: { invitationId: invitation.invitationId }"></ng-container>
                    </span>
                    <span class="invitations-table__status-container">
                        <ng-container [ngTemplateOutlet]="invitationStatus"></ng-container>
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div *ngIf="isMobile && filteredInvitations.length > 0" class="mobile-invitation-container">
        <div *ngFor="let invitation of filteredInvitations; count as invitationCount; last as isLast">
            <p class="mobile-invitation-container__entity-label">{{invitation.legalEntityName}}</p>
            <p><b>Expires: </b>{{invitation.expiresAt}}</p>
            <div *ngIf="isPending" class="mobile-invitation-container__button-container">
                <ng-container *ngTemplateOutlet="invitationButtons; context: { invitationId: invitation.invitationId }"></ng-container>
            </div>
            <ng-container [ngTemplateOutlet]="invitationStatus"></ng-container>
            <hr *ngIf="!isLast">
        </div>
    </div>

    <div *ngIf="filteredInvitations.length === 0">
        <p><i>You do not currently have any {{statusName}} invitations.</i></p>
    </div>
</div>

<ng-template #invitationButtons let-invitationId="invitationId">
    <button class="a-rounded-button--primary-outline button__invitation" (click)="rejectInvitation(invitationId)">Reject</button>
    <button class="a-rounded-button--primary button__invitation" (click)="acceptInvitation(invitationId)">Accept</button>
</ng-template>

<ng-template #invitationStatus>
    <div *ngIf="isAccepted" class="invitation-status">
        <i class="material-icons accepted">check</i>
        <p class="accepted">Accepted</p>
    </div>
    <div *ngIf="isRejected" class="invitation-status">
        <i class="material-icons declined">close</i>
        <p class="declined">Declined</p>
    </div>
</ng-template>

<app-spinner *ngIf="showSpinner" class="spinner spinner_left"></app-spinner>